import { useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import LinearProgress from '@mui/material/LinearProgress';

export default function CapturaDocumento() {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [capturedImage, setCapturedImage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState('');
    const [uploadLembrete, setUploadLembrete] = useState('');
  
    const streamRef = useRef(null);

    useEffect(() => {
        const startCamera = async () => {
            try {
                const mediaStream = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: { exact: 'environment' } },
                    // video: { facingMode: "user" },
                    audio: false,
                });
                if (videoRef.current) {
                    videoRef.current.srcObject = mediaStream;
                    streamRef.current = mediaStream;
                }
            } catch (err) {
                console.error('Erro ao acessar câmera:', err);
                alert('Não foi possível acessar a câmera');
            }
        };

        startCamera();

        return () => {
            streamRef.current?.getTracks().forEach((track) => track.stop());
        };
    }, []);

    // Captura a foto
    const capturePhoto = () => {
        const video = videoRef.current;
        const canvas = canvasRef.current;

        if (video && canvas) {
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        
            canvas.toBlob((blob) => {
                setCapturedImage(blob);
                setShowModal(true);
            }, 'image/jpeg', 10); // 80% de qualidade
        }
    };

    const navigate = useNavigate();

    // Envia para o FastAPI
    const sendToAPI = async () => {
        if (!capturedImage) return;

        setLoading(true);
        setUploadStatus(`Documento sendo processado...`);
        setUploadLembrete('Em torno de 40s terá o retorno da análise do documento')

        try {
            const formData = new FormData();
            
            formData.append('documento', capturedImage, 'documento.jpg');

            const response = await fetch(

                `https://api-visitante.hebraica.org.br/api-documento/upload/identificacao=2/2`,
                {   
                    method: 'POST',
                    body: formData,
                }
            );
            
            const responseData = await response.json();
            
            if(responseData.authorized){

                setUploadStatus('Processamento concluído!');

                await new Promise(resolve => setTimeout(resolve, 1000));
                
                navigate('/confirma-validacao')

                setShowModal(false);

                return
            }

            setUploadStatus('Erro no processamento do documento!');

            navigate('/erro-validacao')
           
            setShowModal(false);

        } catch (error) {
            console.error('Erro ao enviar:', error);
            setUploadStatus(`Erro: ${error.message}`);
            await new Promise(resolve => setTimeout(resolve, 3000));
        } finally {
            setLoading(false);
            setUploadStatus('');
        }
    };

    return (
        <div style={styles.container}>
        <video ref={videoRef} autoPlay playsInline style={styles.video} />
        <div style={styles.frame}></div>
        
        <button onClick={capturePhoto} style={styles.captureButton}>
            📸
        </button>
        
        <canvas ref={canvasRef} style={{ display: 'none' }} />

        {showModal && (
            <div style={styles.modalOverlay}>
                <div style={styles.modal}>
                <h1>CONFIRME A FOTO</h1>
                <img 
                    src={URL.createObjectURL(capturedImage)} 
                    alt="Documento capturado" 
                    style={styles.previewImage} 
                />
                
                <div style={styles.modalButtons}>
                    {loading ? (
                        <div sx={{ width: '100%' }}>
                            <LinearProgress />
                            <p style={styles.statusText}>{uploadStatus}</p>
                            <p style={styles.statusText}>{uploadLembrete}</p>
                        </div>
                    ) : (
                        <>
                        <button 
                            onClick={() => setShowModal(false)} 
                            style={styles.retryButton}
                            disabled={loading}
                            >
                            Tirar Novamente
                            </button>
                            
                            <button 
                            onClick={sendToAPI} 
                            style={styles.confirmButton}
                            disabled={loading}
                            >
                            {loading ? 'Processando...' : 'Confirmar e Enviar'}
                            </button>
                        </>
                    )}
                    
                </div>
                </div>
            </div>
        )}
        </div>
    );
}

    // Estilos
const styles = {
    container: {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: '#000',
        zIndex: 1000,
        overflow: 'hidden',
    },
    video: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    frame: {
        position: 'absolute',
        top: '25%',
        left: '15%',
        width: '70%',
        height: '50%',
        border: '3px dashed #00ff99',
        borderRadius: '10px',
        zIndex: 2,
        pointerEvents: 'none',
    },
    captureButton: {
        position: 'absolute',
        bottom: 40,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#fff',
        border: '4px solid #00aa88',
        borderRadius: '50%',
        width: 100,
        height: 100,
        fontSize: 50,
        zIndex: 3,
        cursor: 'pointer'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modal: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 10,
        maxWidth: '90%',
        textAlign: 'center',
    },
    previewImage: {
        maxWidth: '100%',
        maxHeight: '60vh',
        margin: '10px 0',
        border: '1px solid #ddd',
    },
    modalButtons: {
        display: 'flex',
        justifyContent: 'center',
        gap: 10,
        marginTop: 10,
    },
    retryButton: {
        padding: '18px 30px',
        backgroundColor: '#f44336',
        color: 'white',
        border: 'none',
        borderRadius: 5,
        cursor: 'pointer',
        fontSize: '1.2rem',
        textTransform: 'uppercase', 
        fontWeight: 'bold'
    },
    confirmButton: {
        padding: '18px 30px',
        backgroundColor: '#4CAF50',
        color: 'white',
        border: 'none',
        borderRadius: 5,
        cursor: 'pointer',
        fontSize: '1.2rem',
        textTransform: 'uppercase', 
        fontWeight: 'bold'
    },
    statusText: {
        fontSize: '1.6rem'
    }
};